// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
// css
import '../../styles/components/usage/UsageQuestionForm.scss';

const ANSWERS = [
  ['No', 0],
  ['Partial', 1],
  ['Yes', 2]
];


class UsageQuestionForm extends Component {

  makeHandleClick(value) {
    return () => {
      this.props.updateAnswer(this.props.dsaUserQuestion.id, value);
    };
  }

  renderButtons() {
    const currentAnswer = this.props.dsaUserQuestion.answer;

    return ANSWERS.map(answer => {
      const [label, value] = answer;
      const isSelected = currentAnswer === value;
      return (
        <Button
          key={value}
          onClick={this.makeHandleClick(value)}
          label={label}
          primary={isSelected}
        />
      );
    });
  }

  render() {
    const { userQuestion: q, dsaUserQuestion: auq } = this.props;
    const answer = auq.answer;

    return (
      <div className='usage-question-form row'>
        <div className='col-xs-12 col-sm-5'>
          <label className='h6 usage-question-form__title'>{ q.title } <span className='hidden'>{answer}</span></label>
        </div>
        <div className='col-xs-12 col-sm-7'>
          <div className='usage-question-form__options'>
            {this.renderButtons()}
          </div>
        </div>
      </div>
    );
  }
}

UsageQuestionForm.propTypes = {
  userQuestion: PropTypes.object,
  dsaUserQuestion: PropTypes.object,
  updateAnswer: PropTypes.func
};

export default UsageQuestionForm;



// WEBPACK FOOTER //
// ./src/components/usage/UsageQuestionForm.js